import { GridColDef } from '@mui/x-data-grid'
import { ColumnDate, ColumnLink } from '~/shared/ui/AsyncGrid'
import { ChipStatus } from '~/shared/ui/Chips'
import { GridRow } from './types'

export const columns: GridColDef<GridRow>[] = [
  {
    field: 'id',
    headerName: 'ID',
    minWidth: 110,
    sortable: false,
    renderCell: ({ row }) => <ColumnLink to={row.id}>{row.id}</ColumnLink>,
  },
  {
    field: 'name',
    headerName: 'Название',
    sortable: false,
    minWidth: 240,
  },
  {
    field: 'title',
    headerName: 'Заголовок',
    sortable: false,
    minWidth: 240,
  },
  {
    field: 'content',
    headerName: 'Текст сообщения',
    minWidth: 240,
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'Статус',
    field: 'status',
    sortable: false,
    minWidth: 240,
    renderCell: ({ value }) => (
      <ChipStatus label={value.label} variant={value.color} />
    ),
  },
  {
    headerName: 'Статус водителя',
    field: 'userStatus',
    sortable: false,
    minWidth: 240,
    renderCell: ({ value }) =>
      Array.isArray(value) ? (
        <>
          {value.map((status, index) => (
            <ChipStatus
              key={index}
              label={status.label}
              variant={status.color}
            />
          ))}
        </>
      ) : null,
  },
  {
    headerName: 'Активный',
    field: 'isActive',
    sortable: false,
    minWidth: 110,
    renderCell: ({ value }) => (
      <ChipStatus
        label={value ? 'Да' : 'Нет'}
        variant={value ? 'yellow' : 'gray'}
      />
    ),
  },
  {
    headerName: 'Дата и время',
    field: 'scheduledAt',
    sortable: false,
    minWidth: 240,
    renderCell: ({ value }) => <ColumnDate type='dateTime' value={value} />,
  },
]
